<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
        <gj-warehouse-select
          v-model="filter.warehouseIds"
          width="180px"
          multiple
        ></gj-warehouse-select>

        <gj-select-input
          v-model="filter.keyword"
          :options="[
            { id: 'replacementOrderId', text: '移除订单编号' },
            { id: 'msku', text: 'MSKU' },
            { id: 'fnsku', text: 'FNSKU' },
          ]"
          :width="['120px', '150px']"
        >
        </gj-select-input>

        <gj-select
          placeholder="移除类型"
          collapse-tags
          v-model="filter.orderType"
          :width="'190px'"
          :options="REMOVAL_OPTIONS"
        />
        <gj-select
          placeholder="订单状态"
          collapse-tags
          v-model="filter.orderStatus"
          :width="'190px'"
          :options="[
            { id: 'Pending', text: '处理中' },
            { id: 'Completed', text: '已完成' },
            { id: 'Cancelled', text: '已取消' },
          ]"
        />

        <gj-date-picker type="daterange" v-model="filter.date" />

        <template #right>
          <gj-tool-group
            help
            setting
            :table-name="tableName"
            :table-columns="columns"
            :sort-gjtable="$refs.gjTable"
            :download="$permission('removalShipment:export')"
            download-url="/operation/removalShipment/export"
            :download-params="globalParams"
          >
          </gj-tool-group>
          <view-setting
            :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-change="handleChangeView"
            @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>

    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        :name="tableName"
        :data="tableData"
        :columns="columns"
        :loading="loading"
        sortable="custom"
        :default-sort="{ prop: 'marketTime', order: 'descending' }"
        :size="'has-picture'"
        :pagination="pagination"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:orderStatusName="{ row }">
          <gj-tag :color="getColor(row.orderStatus)" type="plain">
            {{row.orderStatusName}}
          </gj-tag>
        </template>
        <template v-slot:op="{ row }">
          <gj-button type="text" @click="view(row)">详情</gj-button>
        </template>

      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { queryMixin } from "@/minxins";
import { isMeaningful } from "@/utils/common";
import { exportRemovalShipment, getRemovalShipmentPage } from "@/api/sale";
import { convertToDate, generateViewParams } from "@/utils/date.util";
import { REMOVAL_OPTIONS } from "@/utils/options";
import model from "./viewConfig";
import AppViewRemovalShipmentModal from "./modal/view-removal-shipment-modal";
import {tagColors} from "@/components/tag/tag-colors";

export default {
  name: "app-removalShipment",
  mixins: [queryMixin],
  data() {
    return {
      tagColors,
      tableName: "removalShipment",
      columns: [
        // id: 字段ID，用于优化渲染以及自定义列，必填
        // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
        // field: 字段内容域，类型为数据字段名或slot
        // help: 帮助信息（问号）
        // notCustomColumn: 是否是自定义字段，默认：false
        // default: 是否自定义列默认字段
        // {marketName: 'aa', asin: 'asin1'}
        {
          id: "warehouseName",
          header: "仓库",
          field: "warehouseName",
          minWidth: "120px",
          default: true,
          disabled: true,
        },
        {
          id: "orderId",
          header: "移除订单编号",
          field: "orderId",
          minWidth: "110px",
          default: true,
        },
        {
          id: "orderType",
          header: "移除类型",
          field: "orderType",
          minWidth: "100px",
          default: true,
        },
        {
          id: "orderStatusName",
          header: "订单状态",
          field: "slot:orderStatusName",
          minWidth: "100px",
          default: true,
        },
        {
          id: "requestedQuantity",
          header: "请求总数",
          field: "requestedQuantity",
          sortable: true,
          minWidth: "90px",
          align: "right",
          default: true,
        },
        {
          id: "disposedQuantity",
          header: "已弃置",
          field: "disposedQuantity",
          sortable: true,
          minWidth: "90px",
          align: "right",
          default: true,
        },
        {
          id: "cancelledQuantity",
          header: "已取消",
          field: "cancelledQuantity",
          sortable: true,
          minWidth: "90px",
          align: "right",
          default: true,
        },
        {
          id: "shippedQuantity",
          header: "已退回",
          field: "shippedQuantity",
          sortable: true,
          minWidth: "90px",
          align: "right",
          default: true,
        },
        {
          id: "inProcessQuantity",
          header: "待生效",
          field: "inProcessQuantity",
          sortable: true,
          minWidth: "90px",
          align: "right",
          default: true,
        },
        {
          id: "marketTime",
          header: "请求时间",
          field: "marketTime",
          minWidth: "120px",
          sortable: true,
          help: "站点时区",
          default: true,
        },
        {
          id: "updateTime",
          header: "更新时间",
          field: "updateTime",
          minWidth: "120px",
          sortable: true,
          help: "北京时区",
          default: true,
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          width: "80px",
          notCustomColumn: true,
        },
      ],
      tableData: [],
      filter: {
        warehouseIds: null,
        orderType: null,
        orderStatus: null,
        keyword: {
          key: "replacementOrderId",
          value: null,
        },
        date: null,
      },

      modalVisible: {
        logModal: false,
        detailModal: false,
        clickDownload: false,
      },
      moduleName: "REMOVAL_SHIPMENT",
      model,
      REMOVAL_OPTIONS,
      cacheOptions: {
        useCache: true,
      },
    };
  },
  created() {
    this.sort.prop = "marketTime";
  },
  methods: {
    getColor(status){
      switch (status){
        case 'Pending':
          return this.tagColors.orange
        case 'Completed':
          return this.tagColors.green
        case 'Cancelled':
          return this.tagColors.lightGray
      }
    },
    $gjCacheCallback(params) {
      return {
        warehouseIds: params.warehouseIds,
      };
    },
    generateViewParams,
    /**
     * 设置全局查询参数
     */
    mergeRemoteParams(params) {
      const date = params.date
        ? params.date
        : [params.startDateTime, params.endDateTime];
      this.filter = Object.assign({}, this.filter, {
        ...params,
        date,
      });
    },
    loadViewComplete() {
      this.$emit("query");
    },
    $gjQueryInitParams() {
      return {
        filter: {
          warehouseIds: null,
          orderType: null,
          orderStatus: null,
          keyword: {
            key: "replacementOrderId",
            value: null,
          },
          date: null,
        },
      };
    },
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
          orderType: this.filter.orderType,
          orderStatus: this.filter.orderStatus,
          startMarketTime: isMeaningful(this.filter.date)
            ? convertToDate(this.filter.date[0])
            : null,
          endMarketTime: isMeaningful(this.filter.date)
            ? convertToDate(this.filter.date[1])
            : null,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      // 关键词查询
      params.model[this.filter.keyword.key] = this.filter.keyword.value;

      this.globalParams = params;
      // 查询
      this.loading = true;
      getRemovalShipmentPage(params)
        .then((data) => {
          if (isMeaningful(data)) {
            this.tableData = data.records;

            this.pagination = this.getPagination(data);
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
    download() {
      exportRemovalShipment(this.globalParams);
    },
    view(record) {
      this.$gjCreate(AppViewRemovalShipmentModal, {
        props: {
          orderId: record.orderId,
          warehouseId: record.warehouseId,
        },
      });
    },
  },
};
</script>

<style scoped></style>
